import React, { useEffect, useContext } from "react"
import Sogehts from "../components/home/Sogehts"
import { getText } from "../components/strapi"
import TextBook, { TextBookKeys } from "../components/Textbook"
import { Context } from "../store/store"
import { Link } from "react-router-dom"
import Spinner from "../components/elements/Spinner"
import MobileMenu from "../components/MobileMenu"
const Promoover: React.FC = () => {
	const { globalState } = useContext(Context)
	function track(label: string) {
		try {
			// eslint-disable-next-line
			let dataLayer = window["dataLayer"] || []
			dataLayer.push({ event: "footer", link: label })
		} catch (e) {}
	}

	useEffect(() => {
		window.scrollTo({
			top: 0,
			left: 0,
			behavior: "smooth",
		})
	}, [])

	return (
		<>
			{globalState.strapi.homepage ? (
				<div className="light bg-greenBG">
					<MobileMenu />
					<div className="relative bg-greenBG">
						<img src="/images/hero-bubbles.jpg" alt="" className="absolute  left-[40%] top-[28%] z-10  h-auto w-[52%]" />
						<img src="/images/over.png" alt="" className="relative z-20 w-full hidden md:block" />
						<img src="/images/over-mobile.png" alt="" className="relative z-20 w-full block md:hidden" />
						<div className="bg-greenBG -mt-20  md:bg-[url(/src/bgimages/sogehts-bubbles.png)] bg-[length:80%_auto] md:bg-[length:100%_auto] bg-center md:bg-top   bg-no-repeat">
							<div className="js-sogehts   relative  z-10  bg-[length:80%_auto] md:bg-[length:100%_auto] bg-center md:bg-top   bg-no-repeat pb-20 lg:pb-[5.5rem]">
								<div className={"mx-auto max-w-[1400px] "}>
									<h2 className="mb-4 pt-24 md:pt-[57px] text-white max-w-[800px] mx-auto">UNSERE GRATIS-TESTEN-AKTION IST SEIT DEM 05.10.2025 BEENDET.</h2>
									<p className="text-white mb-8 text-center md:text-[20px] max-w-[800px] mx-auto">Vielen Dank an alle, die an unserer Aktion teilgenommen haben.</p>
									<p className="text-white mb-8 text-center md:text-[20px] max-w-[800px] mx-auto">
										Du hast noch Fragen zur Aktion? Kein Problem! Kontaktiere uns einfach per E-Mail unter{" "}
										<a href="mailto:info@volvic-gratis-testen.de" className="underline">
											info@volvic-gratis-testen.de
										</a>
										.
									</p>
									<p className="text-white mb-4 text-center md:text-[20px] max-w-[800px] mx-auto">Besuche uns gerne auf volvic.de, um nichts zu verpassen.</p>
									<div className="grid grid-cols-1 items-center mt-12">
										<a
											href="https://www.volvic.de"
											className=" tracking-wide mb-6 block w-[100%] rounded-full bg-[#FFDD08]   text-center md:mx-auto p-4 font-Veener text-[29px]  sm:text-[42px] leading-none font-bold uppercase text-[#007331] sm:w-[auto]  lg:inline-block lg:py-2 lg:px-6"
											style={{
												boxShadow: "0px 2.21px 16.575px 0px rgba(0, 0, 0, 0.40)",
											}}
										>
											zur volvic Website
										</a>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			) : (
				<div className="py-20 text-center">
					<Spinner />
					<TextBook textKey={TextBookKeys.HOMEPAGE} />
				</div>
			)}
		</>
	)
}
export default Promoover
